<template>
<div class="temporal-widget">
  <div class="temporal-header">
    <span>Temporal player</span>
    <b-button @click="temporalShow = false" size="sm" variant="dark" type="dark" class="headerSmallButton">
      <icon name="window-close" scale=".7"></icon>
    </b-button>
  </div>
  <div class="flex-full-height">
    <div class="temporal-layers border border-secondary border-right-0 border-left-0">
      <div class="d-flex flex-row" data-showui="temporal" data-intro="Here temporal layers listed. They all are put into common timescale. You can remove them here. A layer can be added to temporal scale in Layer Manager." data-step="15">
        <template v-for="layer in temporalLayers">
            <div class="temporal-layer p-1 border border-secondary border-left-0 border-top-0 border-bottom-0">
              {{layer.title || layer.name}}
              <!-- Temporary Fix -->
              <!-- TODO: move temporal logic from componant, and renable button -->
              <!-- <icon class="close-btn" name="window-close" @click.native="removeTemporalLayer(layer)"></icon> -->
            </div>
          </template>
        <div class="pl-2 float-right">
          <b-form-checkbox v-model="slidingWindow" :value="true" :unchecked-value="false">
            sliding window
          </b-form-checkbox>
        </div>
        <div class="h-100 p-1 float-right">
          <icon name="spinner" pulse v-show="isLoading"></icon>
        </div>
      </div>
    </div>
    <div class="temporal-bar d-flex">
      <b-button :disabled="playingDisabled" :pressed.sync="playing" class="float-left">
        <icon :name="playing ? 'pause' : 'play'"></icon>
      </b-button>
      <svg ref='svg' class="w-100 h-100 temporal-timescale"></svg>
    </div>
  </div>
</div>
</template>
<script>
import {
  scaleTime
} from 'd3-scale'
import {
  timeMonth
} from 'd3-time'
import {
  select,
  event
} from 'd3-selection'
import {
  axisBottom
} from 'd3-axis'
import {
  brushX,
  brushSelection
} from 'd3-brush'
import Icon from '../../../node_modules/vue-awesome/components/Icon.vue'
import 'vue-awesome/icons/play'
import 'vue-awesome/icons/pause'
import 'vue-awesome/icons/window-close'
import each from 'async/each'
import WindowHeader from '../common/WindowHeader'

export default {
  components: {
    WindowHeader,
    Icon
  },
  name: 'temporal-scale',
  created() {
    this.b = null
    this.scale = null
    this.coverage = null
    this.paddingLeft = null
    this.nextDateRange = []
    this.minDate = null
    this.maxDate = null
    this.brushNode = null
  },
  data() {
    return {
      loading: false,
      playing: false,
      playingDisabled: true,
      initialised: false,
      slidingWindow: false,
      iterationCounter: 0
    }
  },
  methods: {
    parseDate(strDate) {
      let arr = strDate.split('-')
      let y = parseInt(arr[0])
      let m = parseInt(arr[1]) - 1
      let d = parseInt(arr[2])
      return new Date(y, m, d)
    },
    addYear(d, v) {
      let year = d.getFullYear()
      let month = d.getMonth()
      let day = d.getDate()
      return new Date(year + v, month, day)
    },
    addMonth(d, v) {
      let year = d.getFullYear()
      let month = d.getMonth()
      let day = d.getDate()
      return new Date(year, month + v, day)
    },
    renderChart(minDate, maxDate) {
      let svg = select(this.$refs.svg)
      svg.selectAll('*').remove()
      let bbox = this.$refs.svg.getBoundingClientRect()
      this.paddingLeft = 2
      let paddingRight = 20
      let paddingTop = 2
      //        let paddingBottom = 10
      //         let width = bbox.width - this.paddingLeft - paddingRight
      this.scale = scaleTime().domain([minDate, maxDate]).nice(timeMonth).range([this.paddingLeft, bbox.width - paddingRight])

      svg.append('g')
        .attr('transform', 'translate(' + this.paddingLeft + ',' + paddingTop + ')')
        .call(axisBottom().scale(this.scale).ticks(timeMonth))

      svg.selectAll('g.tick line')
        .attr('y2', function(d) {
          if (d.getMonth() === 0) {
            return 10
          } else {
            return 4
          }
        })
      svg.selectAll('g.tick text').attr('y', 12).text(function(d) {
        return d.getMonth() === 0 ? d.getFullYear() : ''
      })

      let onBrush = () => {
        let start = this.scale.invert(event.selection[0])
        let end = this.scale.invert(event.selection[1])
        this.updateDateRange(start, end)
      }

      this.b = brushX()
        .extent([
          [0, 0],
          [bbox.width - paddingRight, bbox.height]
        ])
        .on('end', onBrush)

      let slider = svg.append('g')
        .attr('class', 'slider')
      this.brushNode = slider.node()

      this.coverage = slider.call(this.b)

      this.b.move(this.coverage, [0, bbox.width - paddingRight])
    },
    removeTemporalLayer(layer) {
      layer['cql_custom'] = null
      this.$mapService.forceCreateLayer(layer)
      this.$store.commit('map/removeTemporalLayer', layer)
    },
    updateDateRange(start, end) {
      each(this.temporalLayers, (l, clb) => {
        let c = [l['cql'], l['temporal_field'] + ' BETWEEN ' + start.toISOString() + ' AND ' + end.toISOString()]
        l['cql_custom'] = c.filter(i => i).join(' AND ')
        l['wms_time'] = [start.toISOString(), end.toISOString()].join('/')
        this.updateWfsLayer(l, clb)
      }, () => {
        if (this.playing) {
          setTimeout(() => {
            this.nextRange()
          }, 250)
        }
      })
    },
    nextRange() {
      let sel = brushSelection(this.brushNode)
      let ds = this.scale.invert(sel[0])
      let de = this.scale.invert(sel[1])

      de = this.addMonth(de, 3)
      if (this.slidingWindow) {
        ds = this.addMonth(ds, 3)
      }

      this.b.move(this.coverage, [this.scale(ds), this.scale(de)])

      if (
        (this.playing && this.slidingWindow && ds.getTime() > this.maxDate.getTime()) ||
        (this.playing && !this.slidingWindow && de.getTime() > this.maxDate.getTime())
      ) {
        if (this.iterationCounter > 0) {
          this.b.move(this.coverage, [this.scale(this.minDate), this.scale(this.maxDate)])
          this.iterationCounter = 0
          this.playing = false
        } else {
          this.b.move(this.coverage, [this.scale(this.minDate), this.scale(this.addMonth(this.minDate, 3))])
          this.iterationCounter++
        }

      }

    },
    updateWfsLayer(layer, callback) {
      let exists = this.$mapService._layerExists(layer)
      if (!exists) {
        this.$mapService.forceCreateLayer(layer)
      } else {
        let stopLoading = () => {
          layer['loading'] = false
          this.$store.dispatch('map/layerState', layer)
          callback(null)
        }

        if (layer['data_type'] === 'wfs') {
          let vectorSource = this.$mapService._getVectorSource(layer)

          layer['loading'] = true
          this.$store.dispatch('map/layerState', layer)
          let url = vectorSource.getUrl()()
          this.$http.get(url)
            .then(res => {
              let features = vectorSource.getFormat().readFeatures(res.body)
              exists.getSource().getFeatures().forEach(f => exists.getSource().removeFeature(f))
              exists.getSource().addFeatures(features)
              stopLoading()
            }, res => {
              console.error(res)
              stopLoading()
            })
        } else {
          //            we assume only single image WMS currently supported
          let wmsSource = exists.getSource()
          let params = wmsSource.getParams()
          params['time'] = layer['wms_time']
          let imgLoaded = () => {
            setTimeout(() => {
              stopLoading()
            }, 200)
            wmsSource.un('imageloadend', imgLoaded)
            wmsSource.un('imageloaderror', imgLoaded)
          }

          wmsSource.on('imageloadend', imgLoaded)
          wmsSource.on('imageloaderror', imgLoaded)

          wmsSource.updateParams(params)
        }
      }
    },
    updateScale(layers) {
      if (!layers.length) {
        return
      }
      this.loading = true
      this.$http.get('/api/layers/date-range', {
          params: {
            ids: layers.map(l => l.id).join(',')
          }
        })
        .then(res => {
          if (!res.body.min_date) {
            console.log("No temporal scale")
            return
          }
          this.minDate = this.parseDate(res.body.min_date)
          this.maxDate = this.parseDate(res.body.max_date)
          this.loading = false
          this.playingDisabled = false
          this.renderChart(this.minDate, this.maxDate)
        }, res => {
          this.loading = false
          this.$notify({
            title: 'ERROR',
            text: 'Could not gate date range',
            type: 'error'
          })
        })
    }
  },
  computed: {
    resizeMap() {
      return this.$store.getters['map/widgetResizeMap']['tmp_scale']
    },
    temporalLayers() {
      return this.$store.getters['map/temporalLayers']
    },
    isLoading() {
      return this.loading || this.temporalLayers.filter(l => l.loading).length > 0
    },
    temporalShow: {
      get() {
        return this.$store.getters['map/temporalShow']
      },
      set(val) {
        this.$store.commit('map/temporalShow', val)
      },
    }
  },
  watch: {
    resizeMap() {
      this.updateScale(this.temporalLayers)
    },
    playing(val) {
      if (val) {
        let unloadedLayers = this.temporalLayers.filter(l => !this.$mapService._layerExists(l))
        if (unloadedLayers.length > 0) {
          this.$notify({
            title: 'WARNING',
            text: 'Not all layers loaded. Please, wait',
            type: 'warning'
          })
          this.playing = false
          return
        }

        this.nextRange()
      }
    },
    temporalLayers(val) {
      this.updateScale(val)
    }
  },
  mounted() {
    this.updateScale(this.temporalLayers)
  },
  destroyed() {
    this.$store.commit('map/temporalLayers', [])
  }
}
</script>>



// WEBPACK FOOTER //
// src/components/map/TemporalScale.vue